<template>
  <div class="not-found d-flex flex-column">
    <div class="flex-grow-1 d-flex align-center justify-center">
        <div class="text-center">
            <h1 class="display-3">Cette page n'existe pas...</h1>
            <h2 class="display-1">:(</h2>
        </div>
    </div>

    <Footer style="z-index: 100;"/>
  </div>
</template>

<script>
import Footer from '@/components/Footer'

export default {
  name: 'NotFound',
  components: {
    Footer,
  },
  data() {
    return {}
  },
  methods: {
    run(method, params = null) {
      if(typeof this[method] === 'function') {
        !!params ? this[method](params) : this[method]()
      }
      else {
        this.$emit('run', method, params)
      }
    },
  },
}
</script>

<style scoped>

</style>
